module.exports = __webpack_public_path__ + "static/img/cashWheelImg.7d4cdbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/cashWheelImg.png
// module id = /01m
// module chunks = 0